import InfoNotice from '@modules/products/components/info-notice';

type Props = {
  notForSale?: boolean;
};

/**
 * Shown on the PDP of a product that has been carried over for SEO but is not
 * yet available to purchase (review tool `not_for_sale` flag). The page stays
 * live and indexable; this notice explains why the buy button is disabled.
 */
export default function NotForSaleNotice({ notForSale }: Props) {
  if (!notForSale) return null;

  return (
    <InfoNotice>
      This product is not currently available to purchase online.
    </InfoNotice>
  );
}
